import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@lightspeed/flame/Text';

interface ReceiptItemNoteProps {
  lineNumber: number;
  note: string;
  description: string;
  hasUntaxedItems: boolean;
  tax: boolean;
  isGroupedItemHead: boolean;
}

const ReceiptItemNote: React.FunctionComponent<ReceiptItemNoteProps> = ({
  note,
  description,
  lineNumber,
  hasUntaxedItems,
  tax,
  isGroupedItemHead,
}) => {
  const { t } = useTranslation();
  if (!note || isGroupedItemHead) return null;

  const trimGiftcardNote = (note: string) =>
    /^Gift\sCard\sPurchase\s\d+$/.test(note) ? t('receipt.giftCard') : note;

  return (
    <Text
      pt={description ? 1 : undefined}
      lineHeight="normal"
      size={description ? 'small' : 'large'}
      color={description ? 'gray-400' : 'gray-800'}
      data-testid={`saleLine-${lineNumber}-note`}
    >
      {trimGiftcardNote(note)}
      {!description ? <>{hasUntaxedItems && !tax ? ' *' : ''}</> : null}
    </Text>
  );
};

export { ReceiptItemNote };
